export default __webpack_public_path__ + "static/stred-veže-c780451e376ae0e97743d694af6cf916.jpg";